import React from 'react';
import StatusSelectOption from '../../../../components/status-select/StatusSelectOption';
import { StatusKeys } from '../../../../components/status-select/types';
import { FormSelect } from '../../../../components';
import useProjectStatuses from '../../../../hooks/useProjectStatuses';

type Props = {
  disabled?: boolean;
};

const StatusSelect = ({ disabled = false }: Props) => {

  const items = useProjectStatuses();

  return (
    <FormSelect
      label="Status"
      name="status_id"
      disabled={disabled}
      items={items}
      customOption={(title: string, optionKey: string) => (
        <StatusSelectOption
          title={title}
          statusKey={parseInt(optionKey, 10) as StatusKeys}
        />
      )}
      useBlankSelectBeforeInit
    />
  );
};

export default StatusSelect;
